import { useEffect, useRef, useState } from "react";
import { getProducts } from "@/lib/api";
import { Seo } from "@/components/Seo";
import { ProductCard } from "@/components/ProductCard";
import { Search } from "lucide-react";

export default function SearchPage() {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const [searched, setSearched] = useState(false);
  const [loading, setLoading] = useState(false);
  const timer = useRef(null);

  useEffect(() => {
    clearTimeout(timer.current);
    if (q.trim().length < 2) {
      setResults([]);
      setSearched(false);
      return;
    }
    timer.current = setTimeout(() => {
      setLoading(true);
      getProducts({ q: q.trim(), limit: 24 }).then((r) => {
        setResults(r);
        setSearched(true);
      }).catch(() => {
        setResults([]);
        setSearched(true);
      }).finally(() => setLoading(false));
    }, 350);
    return () => clearTimeout(timer.current);
  }, [q]);

  return (
    <>
      <Seo title="Ara" path="/ara"  noindex />
      <div className="container-shule py-10 lg:py-16">
        <h1 className="font-serif text-4xl lg:text-5xl text-shule-coffee">Ara</h1>
        <div className="mt-8 flex items-center gap-3 rounded-full border border-shule-lineaccent bg-shule-paper px-5 focus-within:border-shule-gold transition-colors max-w-xl">
          <Search className="w-5 h-5 text-shule-soft shrink-0" />
          <input
            data-testid="search-input"
            type="search"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Ürün, kategori, tarz veya kullanım anı ara…"
            autoFocus
            className="flex-1 min-w-0 bg-transparent min-h-[56px] text-base outline-none"
          />
        </div>

        {q.trim().length > 0 && q.trim().length < 2 && (
          <p className="mt-4 text-sm text-shule-soft">Aramak için en az 2 karakter yaz.</p>
        )}
        {loading && <p className="mt-6 text-sm text-shule-soft">Aranıyor…</p>}
        {searched && !loading && (
          <p data-testid="search-results-count" className="mt-6 text-sm text-shule-soft">
            “{q.trim()}” için {results.length} sonuç
          </p>
        )}
        <div className="mt-8 grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
          {results.map((p, i) => <ProductCard key={p.slug} product={p} index={i} />)}
        </div>
        {searched && !loading && results.length === 0 && (
          <p data-testid="search-no-results" className="text-center text-shule-soft py-16 font-serif text-2xl">
            Aramanla eşleşen ürün bulamadık. Kategori, tarz veya kullanım anı ile tekrar deneyebilirsin.
          </p>
        )}
      </div>
    </>
  );
}
